// LabelPickerSheet — Label für die markierten Karten wählen (Auswahl-Modus). Zuweisen
// ist im Batch das einzige Label-Verhalten; Entfernen läuft je Karte über das ⋮-Menü
// im Viewer.
import React from 'react';
import { Plus } from 'lucide-react';
import BottomSheet from '../../../../ui/BottomSheet';
import List from '../../../../ui/List';

export default function LabelPickerSheet({ open, onOpenChange, labels = [], onSelect, onCreateNew }) {
  const choose = (handler) => () => {
    onOpenChange?.(false);
    handler();
  };

  return (
    <BottomSheet open={open} onOpenChange={onOpenChange} title="Label zuweisen">
      <List>
        {labels.map((label) => (
          <List.Item key={label.id} onClick={choose(() => onSelect?.(label))}>
            <List.Main>
              <List.Name>
                {/* Farbpunkt + Name wie in den Label-Zeilen des Karten-Menüs. */}
                <span className="card-label-row">
                  <span
                    className="card-label-row__color"
                    style={{ background: `var(--label-${label.color})` }}
                  />
                  <span className="card-label-row__name">{label.name}</span>
                </span>
              </List.Name>
            </List.Main>
          </List.Item>
        ))}
        {typeof onCreateNew === 'function' && (
          <List.Item onClick={choose(onCreateNew)}>
            <List.Main>
              <List.Name>
                <span className="mobile-category-picker__row">
                  <Plus size={14} aria-hidden /> Neues Label…
                </span>
              </List.Name>
            </List.Main>
          </List.Item>
        )}
      </List>
    </BottomSheet>
  );
}
